export default "__VITE_ASSET__D6CR7660__"